import React, { useState } from "react";
import Layout from "@/components/Layout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

const ITEMS = [
  { title: "Sponsor & Artist Marketplace", desc: "Match with brands & talent, book gigs, close deals." },
  { title: "Loyalty Leaderboard", desc: "Rank against your city. Win drops. Flex the points." },
  { title: "Brand Campaign Dashboard", desc: "Track ROI across events, audiences, cities." },
  { title: "Ecosystem Lead Marketplace", desc: "Vendors & creators discover live event opportunities." },
  { title: "Eventom Club Full VIP Benefits", desc: "Invite-only tier with concierge, backstage & lounge access." },
  { title: "Biz Plan for Organisers", desc: "1% commission, fast payouts, full attendee data, AI photo gallery." },
];

export default function ComingSoon() {
  const [phone, setPhone] = useState("");
  const [subscribed, setSubscribed] = useState({});
  const [busy, setBusy] = useState("");

  const notify = async (title) => {
    if (!phone || phone.replace(/\D/g, "").length < 10) { toast.error("Add a valid mobile number"); return; }
    setBusy(title);
    try { await api.post("/biz-plan/notify", { phone }); setSubscribed((s) => ({ ...s, [title]: true })); toast.success("You're on the list"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Failed"); }
    finally { setBusy(""); }
  };

  return (
    <Layout>
      <section className="relative overflow-hidden py-16 border-b border-line" style={{ background: "radial-gradient(ellipse at top, rgba(255,77,109,0.3), transparent 60%), radial-gradient(ellipse at bottom, rgba(123,47,255,0.35), transparent 60%), #0A0A0A" }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <Sparkles className="w-10 h-10 mx-auto text-lime mb-3" />
          <div className="chip bg-pink/20 text-pink mb-3">Coming Soon</div>
          <h1 className="font-display uppercase text-5xl md:text-7xl leading-[0.9]">The <span className="grad-text-hot">next drops.</span></h1>
          <p className="mt-3 text-text/85 max-w-2xl mx-auto">Drop your mobile. We'll ping you the second these go live.</p>
          <div className="mt-6 max-w-md mx-auto">
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+91 9XXXXXXXXX" inputMode="tel" className="input-dark" data-testid="cs-phone-input" />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {ITEMS.map((it) => (
            <div key={it.title} className="glass rounded-3xl p-6 card-lift" data-testid={`cs-card-${it.title.replace(/\s+/g, "-").toLowerCase().slice(0, 24)}`}>
              <span className="text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded-full bg-pink text-white inline-block mb-3">Coming Soon</span>
              <div className="font-display uppercase text-2xl leading-tight">{it.title}</div>
              <div className="text-sm text-muted mt-2">{it.desc}</div>
              <button onClick={() => notify(it.title)} disabled={!!subscribed[it.title] || busy === it.title} className="btn-primary mt-4 !py-2 !px-4 !text-xs" data-testid={`cs-notify-${it.title.replace(/\s+/g, "-").toLowerCase().slice(0, 24)}`}>
                {busy === it.title ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : subscribed[it.title] ? "✓ On the list" : "Notify Me"}
              </button>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
